import React from "react";
import logo from "../../assets/images/logo.png";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { toast } from "react-toastify";
import { auth } from "../../firebase";

interface HeaderProps {
    isShowLogout?: boolean; // Optional: can hide/show based on page
    buttonTitle?: string; // Optional: to change the header button text
    targetPath?: string; // Optional: where the button should lead
}

const Header: React.FC<HeaderProps> = ({ 
    isShowLogout = true, 
    buttonTitle = "", 
    targetPath = "" 
}) => {
    const navigate = useNavigate();

     const handleLogout = async () => {
        if (window.confirm("Are you sure you want to logout?")) {
            try {
                await signOut(auth);
                toast.success("Logged out successfully");
                navigate("/admin/login");
            } catch (error) {
                toast.error("Logout failed");
            }
        }
    };

    return (
        <div className="flex justify-between items-center mb-4 shrink-0">
            {/* Logo */}
            <img src={logo} alt="Logo" className="h-10 w-auto object-contain cursor-pointer" onClick={() => navigate("/")} />

            <div className="flex items-center gap-2">
                {/* Navigation Button */}
                {buttonTitle &&
                    <button
                        onClick={() => navigate(targetPath, { replace: true })}
                        className="bg-black text-white text-[10px] font-bold px-3 py-1.5 rounded-full hover:bg-[#fa3815] transition uppercase"
                    >
                        {buttonTitle}
                    </button>
                }

                {/* Logout Button */}
                {isShowLogout && (
                    <button
                        onClick={handleLogout}
                        className="p-1 text-[#fa3815] hover:bg-[#fa3815]/50 rounded-full transition"
                        title="Logout"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={2}
                            stroke="currentColor"
                            className="w-6 h-6"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9"
                            />
                        </svg>
                    </button>
                )}
            </div>
        </div>
    );
};

export default Header;